/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useState } from "react";

export const ReactTableCell = ({
  header,
  value,
  sncCustomerList /* retailerList */,
}: any) => {
  switch (header) {
    case "status": {
      return (
        <Badge variant={value ? "default" : "destructive"}>
          {value ? "Active" : "Inactive"}
        </Badge>
      );
    }
    case "sku_code": {
      return <SkuCode value={value} />;
    }
    case "customer_branches": {
      return (
        <CustomerBranchesCell value={value} sncCustomerList={sncCustomerList} />
      );
    }
    // case "retailer_id": {
    //   const currentData = retailerList.find(
    //     (item: any) => item.retailer_id === value
    //   );
    //   return (
    //     <span className="uppercase">{currentData?.retailer_name || value}</span>
    //   );
    // }
    case "retailers": {
      const tempValue = value.map((item: any) => item.retailer_name).join(", ");
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="text-gray-900 truncate w-full  inline-block">
              {tempValue}
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <TooltipArrow />
            <ul className="list-inside">
              {value.map((rName: any, idx: number) => (
                <li key={idx} className="uppercase">
                  {rName.retailer_name}
                </li>
              ))}
            </ul>
          </TooltipContent>
        </Tooltip>
      );
    }
    // case "retailer_id": {
    //   const temp_value = value;
    //   if (typeof temp_value === "string") {
    //     const currentData = retailerList.find(
    //       (item: any) => item.retailer_id === temp_value
    //     );

    //     return (
    //       <Tooltip>
    //         <TooltipTrigger asChild>
    //           <span className="text-gray-900 truncate w-full  inline-block">
    //             {currentData?.retailer_name || temp_value}
    //           </span>
    //         </TooltipTrigger>
    //         <TooltipContent>
    //           <TooltipArrow />
    //           <p className="list-inside">
    //             {currentData?.retailer_name || temp_value}
    //           </p>
    //         </TooltipContent>
    //       </Tooltip>
    //     );
    //   }

    //   // If value is an array of strings
    //   if (Array.isArray(temp_value)) {
    //     const mapped = temp_value.map((val: string) => {
    //       const currentData = retailerList.find(
    //         (item: any) => item.retailer_id === val
    //       );

    //       return currentData?.retailer_name || val;
    //     });

    //     return (
    //       <Tooltip>
    //         <TooltipTrigger asChild>
    //           <span className="text-gray-900 truncate w-full  inline-block">
    //             {mapped.join(", ")}
    //           </span>
    //         </TooltipTrigger>
    //         <TooltipContent>
    //           <TooltipArrow />
    //           <ul className="list-inside">
    //             {mapped.map((rName: string, idx: number) => (
    //               <li key={idx} className="uppercase">
    //                 {rName}
    //               </li>
    //             ))}
    //           </ul>
    //         </TooltipContent>
    //       </Tooltip>
    //     );
    //   }

    //   return (
    //     <Tooltip>
    //       <TooltipTrigger asChild>
    //         <span className="text-gray-900 truncate w-full  inline-block">
    //           {value}
    //         </span>
    //       </TooltipTrigger>
    //       <TooltipContent>
    //         <TooltipArrow />
    //         <p className="list-inside">{value}</p>
    //       </TooltipContent>
    //     </Tooltip>
    //   );
    // }

    default: {
      return <span>{value}</span>;
    }
  }
};

type CustomerBranchesCellProps = {
  value: {
    customer_id: string | number;
    customer_name?: string;
    branches?: { id: string | number; name?: string }[];
  }[];
  sncCustomerList: any[];
};

export const CustomerBranchesCell = ({
  value,
  sncCustomerList,
}: CustomerBranchesCellProps) => {
  if (!Array.isArray(value) || value.length === 0) return null;

  const resolved = value.map((item) => {
    const customer = sncCustomerList?.find(
      (cItem: any) => String(cItem?.customer_id) === String(item?.customer_id),
    );
    const branches = Array.isArray(item?.branches) ? item.branches : [];
    const branchNames = branches.map((branch) => branch?.name ?? branch?.id);
    return {
      customerName:
        item?.customer_name || customer?.display_name || item?.customer_id,
      branchNames,
    };
  });

  const summary = resolved.map((item) => item.customerName).join(", ");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="text-gray-900 truncate w-full inline-block">
          {summary}
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <TooltipArrow />
        <ul className="list-inside">
          {resolved.map((item, idx) => (
            <li key={idx}>
              <span className="font-medium">{item.customerName}</span>
              {item.branchNames.length
                ? `: ${item.branchNames.join(", ")}`
                : ""}
            </li>
          ))}
        </ul>
      </TooltipContent>
    </Tooltip>
  );
};

type SkuCodeProps = {
  value: string[] | string;
};

export const SkuCode = ({ value }: SkuCodeProps) => {
  const [expanded, setExpanded] = useState(false);

  if (!value) return null;

  const items = Array.isArray(value) ? value : [value];
  const showToggle = items.length > 1;
  const visibleItems = expanded ? items : items.slice(0, 1);

  return (
    <span className="py-1 flex flex-col">
      <div className="list-type-2">
        {visibleItems.map((item, index) => (
          <div key={index} className="list-item-type">
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="text-gray-900 truncate w-full  py-1 text-center   border px-3  rounded-[50px] inline-block">
                  {item}
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p>{item}</p>
              </TooltipContent>
            </Tooltip>
          </div>
        ))}
      </div>

      {showToggle && (
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="text-primary text-center w-full text-xs font-medium  hover:underline"
        >
          {expanded ? "View less" : `+${items.length - 1} more`}
        </button>
      )}
    </span>
  );
};
